/**
 * 500 MB mirrors the backend's MAX_VIDEO_BYTES, enforced when it downloads the source video.
 * The 30s cap is client-side only — the backend's video_to_gif `duration` input is an ffmpeg `-t` segment length, not a limit on source length.
 */
// biome-ignore lint/style/noMagicNumbers: 1024 * 1024 is the idiomatic way to express bytes-per-megabyte
const BYTES_PER_MB = 1024 * 1024;

export const VIDEO_TO_GIF_MAX_FILE_SIZE_MB = 500;
export const VIDEO_TO_GIF_MAX_FILE_SIZE_BYTES = VIDEO_TO_GIF_MAX_FILE_SIZE_MB * BYTES_PER_MB;
export const VIDEO_TO_GIF_MAX_DURATION_SECONDS = 30;
